// extracted by mini-css-extract-plugin
export default {"pagination":"RecordPagination_pagination__Nbfc-","total":"RecordPagination_total__8HEO-"};